import axios from 'axios'

export const signup = async data => {
  const response = await axios
    .post('/newsletter/store', data)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
